export const BUSINESS_COUNTRY_VALUE_MAP = {
  Other: '__OTHER__',
  UnitedStates: 'US',
  Canada: 'CA',
}

export function createBusinessCountryList(t) {
  return [
    {
      label: t('billing.healthcare.business_country_select.option_label.united_states'),
      value: BUSINESS_COUNTRY_VALUE_MAP.UnitedStates,
    },
    {
      label: t('billing.healthcare.business_country_select.option_label.canada'),
      value: BUSINESS_COUNTRY_VALUE_MAP.Canada,
    },
    {
      label: t('billing.healthcare.business_country_select.option_label.other'),
      value: BUSINESS_COUNTRY_VALUE_MAP.Other,
    },
  ]
}

export function notHealthcareEligibleCountry(businessCountry) {
  return businessCountry === BUSINESS_COUNTRY_VALUE_MAP.Other
}

export function getBusinessCountryByIpLocation(cn) {
  switch (cn) {
    case 'US':
      return BUSINESS_COUNTRY_VALUE_MAP.UnitedStates
    case 'CA':
      return BUSINESS_COUNTRY_VALUE_MAP.Canada
    default:
      return BUSINESS_COUNTRY_VALUE_MAP.Other
  }
}

const createAgreementUrl = (code) => `/healthcare/baa?baa_country=${code}`
export function getAgreementUrlByBusinessCountry(businessCountry) {
  switch (businessCountry) {
    case BUSINESS_COUNTRY_VALUE_MAP.UnitedStates:
      return createAgreementUrl('US')
    case BUSINESS_COUNTRY_VALUE_MAP.Canada:
      return createAgreementUrl('CA')
    default:
      return ''
  }
}

export function getCountryCodeByBusinessCountry(businessCountry) {
  switch (businessCountry) {
    case BUSINESS_COUNTRY_VALUE_MAP.UnitedStates:
      return 'US'
    case BUSINESS_COUNTRY_VALUE_MAP.Canada:
      return 'CA'
    default:
      return ''
  }
}

export function getAgreementAcceptedDesc(businessCountry, t) {
  switch (businessCountry) {
    case BUSINESS_COUNTRY_VALUE_MAP.UnitedStates:
      return t('billing.healthcare.baa_accepted')
    case BUSINESS_COUNTRY_VALUE_MAP.Canada:
      return t('billing.healthcare.phia_accepted')
    default:
      return ''
  }
}

export function getAddressIneligibleHealthcareTipShow(healthcareInfo, addressInfo) {
  return !!(
    healthcareInfo.agreementAccepted &&
    addressInfo &&
    addressInfo.country &&
    healthcareInfo.countryCode !== addressInfo.country
  )
}
